import { action, makeObservable, observable } from 'mobx';

import { analytics } from '../../services/analytics';
import { devLog } from '../../utils/log';
import { type RootStore } from '../RootStore';

export type CoinType = 'GC' | 'SC';
export type ExtendedCoinType = CoinType | 'CASH';

export class CoinTypeStore {
  private readonly rootStore: RootStore;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeObservable(this);
  }

  @observable
  public coinType: CoinType = 'GC';

  @action
  private _setCoinType(coinType: CoinType) {
    this.coinType = coinType;
    analytics.setCommonProps({ lobby_type: coinType === 'GC' ? 'CC' : 'SC' });

    devLog('CoinTypeStore: setCoinType', coinType);

    this.rootStore.gameStore.sendSlotsGameUiMessage({
      type: 'setCoinType',
      payload: {
        coinType,
      },
    });
  }

  private switchToSweepInterceptor?: () => Promise<boolean> = undefined;

  public setSwitchToSweepInterceptor(interceptor?: () => Promise<boolean>) {
    this.switchToSweepInterceptor = interceptor;
  }

  public setCoinType(coinType: CoinType) {
    void this.requestCoinType(coinType);
  }

  /**
   * `setCoinType` for a caller that must know the outcome: resolves true once the lobby is on
   * `coinType`, false when the sweep interceptor refused. Without an interceptor the switch is
   * synchronous, as before.
   */
  public requestCoinType(coinType: CoinType): Promise<boolean> {
    if (!this.switchToSweepInterceptor || coinType !== 'SC') {
      this._setCoinType(coinType);
      return Promise.resolve(true);
    }

    // TODO: we need to rethink this logic
    return this.switchToSweepInterceptor().then((switchConfirmed) => {
      if (switchConfirmed) {
        this._setCoinType(coinType);
      }
      return switchConfirmed;
    });
  }
}
